"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Portrait = require("./Portrait.style");

var Portrait = function Portrait(_ref) {
  var company = _ref.company,
      image = _ref.image,
      jobTitle = _ref.jobTitle,
      name = _ref.name,
      link = _ref.link;
  return /*#__PURE__*/_react.default.createElement(_Portrait.PortraitContainer, null, /*#__PURE__*/_react.default.createElement(_Portrait.PortraitLinkWrapper, Object.assign({
    url: link && link.url
  }, link), /*#__PURE__*/_react.default.createElement(_Portrait.PortraitImageContainer, null, /*#__PURE__*/_react.default.createElement(_Portrait.PortraitImage, Object.assign({
    mediaType: "backgroundImage"
  }, image, {
    aspectRatio: 1,
    alt: name
  })), /*#__PURE__*/_react.default.createElement(_Portrait.PortraitImageContent, null, name && /*#__PURE__*/_react.default.createElement(_Portrait.PortraitName, null, name)))), /*#__PURE__*/_react.default.createElement(_Portrait.PortraitContent, null, jobTitle && /*#__PURE__*/_react.default.createElement(_Portrait.PortraitText, null, jobTitle), company && /*#__PURE__*/_react.default.createElement(_Portrait.PortraitTextSmall, null, company)));
};

Portrait.propTypes = {
  company: _propTypes.default.string,
  image: _propTypes.default.shape({}),
  jobTitle: _propTypes.default.string,
  name: _propTypes.default.string,
  link: _propTypes.default.shape({
    url: _propTypes.default.string
  })
};
Portrait.defaultProps = {
  company: '',
  image: null,
  jobTitle: '',
  name: '',
  link: null
};
var _default = Portrait;
exports.default = _default;